var SERVER_KUBBER = "https://kubber.co:8843";
var SERVER_COUNTRY = "CO"
var SERVER_GESTION = "https://gestionelectronica.co:11901";
var SERVER_GESTION_KEY = "d2Vic2VydmljZTAyOnRhcmdldHQyLjU=";

let hostname = location.hostname.toLowerCase();
switch (hostname) {
    case "mx.lkubber.co":
        SERVER_COUNTRY = "MX"
        SERVER_KUBBER = "http://mx.lkubber.co:8080/mx";
        SERVER_GESTION = "https://gestionelectronica.co:11902"
        SERVER_GESTION_KEY = "d2Vic2VydmljZTAyOnRhcmdldHQyLjU=";
        break;
    case "co.lkubber.co":
        SERVER_COUNTRY = "CO"
        SERVER_KUBBER = "http://co.lkubber.co:8080";
        SERVER_GESTION = "https://gestionelectronica.co:11901"
        SERVER_GESTION_KEY = "d2Vic2VydmljZTAxOnRhcmdldHQyLjU";
        break;
    case "mx.kubber.co":
        SERVER_COUNTRY = "MX"
        SERVER_KUBBER = "https://kubber.co:8843/mx";
        SERVER_GESTION = "https://gestionelectronica.co:11902"
        SERVER_GESTION_KEY = "d2Vic2VydmljZTAyOnRhcmdldHQyLjU=";
        break;
    case "kubber.co":
        SERVER_COUNTRY = "CO"
        SERVER_KUBBER = "https://kubber.co:8843";
        SERVER_GESTION = "https://gestionelectronica.co:11901"
        SERVER_GESTION_KEY = "d2Vic2VydmljZTAxOnRhcmdldHQyLjU";
        break;
    default:
        break;
}


module.exports = {
    PERFIL: 1,
    //FACTOR_CONVERSION: 1.11112,
    VERSION: "1.76",
    NAME: "Kubber",
    SESSION_KEY: "kubber.persona",
    SECRET_KEY: "eTVRBME5UWTNOalUx4T0E9PTAxMjE3NjBkLTZmNmMtNDk0Ny1hM58e93e=",
    STORE_KEY_RECAPTCHA: '6Lf_UTAfAAAAADVN2ugW8d8dz3HhvMWsd5JizE17',
    BASIC_API: SERVER_GESTION_KEY,
    BASE_URL: SERVER_GESTION,
    SERVER_HOST: SERVER_KUBBER,

    COUNTRY: SERVER_COUNTRY,

    COLOR_PERFIL: {
        1: "bg-kubber",
        2: "bg-kubber",
        3: "bg-kubber",
        4: "bg-kubber",
        5: "bg-taller",
        6: "bg-financiera",
    },

    PERFILES: {
        FINANCIERA: "Ng==",
        ESTACION: "Mw==",
    },

    EMPRESAS: { 
        KUBBER: "9",
    },

    API_GET_LOGIN: '/comandos/api/parametros/login',

    API_GET_FACTURA: SERVER_KUBBER + '/kubber/facturacion/api/v1/factura',

    API_GET_FACTURA_REINTENTAR_CO: SERVER_KUBBER + '/kubber/facturacion/api/v1/reintentar',
    API_GET_FACTURA_REINTENTAR_MX: SERVER_KUBBER + '/kubber/facturacion/api/v1/enviar/factutar40',
    API_GET_FACTURA_CONSULTA_MX: SERVER_KUBBER + '/kubber/facturacion/api/v1/consulta/factutar40',

    API_GET_REPORTE_VENTAS: SERVER_KUBBER + '/kubber/movimientos/api/v1/lista',
    API_GET_REPORTE_VENTAS_PARA_FACTURAR: SERVER_KUBBER + '/kubber/movimientos/api/v1/lista/disponible/facturar',
    API_GET_REPORTE_CANASTILLA: SERVER_KUBBER + '/kubber/movimientos/api/v1/lista/venta_canastilla',
    API_GET_REPORTE_FACTURA_ELECTRONICA: SERVER_KUBBER + '/kubber/movimientos/api/v1/lista/facturas_electronicas',
    API_GET_REPORTE_FACTURA_ELECTRONICA_LIMITED: SERVER_KUBBER + '/kubber/movimientos/api/v1/lista/limited/facturas_electronicas',
    API_GET_REPORTE_CONCILIACIONES: SERVER_KUBBER + '/kubber/movimientos/api/v1/conciliacion',


    API_GET_REPORTE_VENTAS_DESPACHOS: SERVER_KUBBER + '/kubber/movimientos/api/v1/lista/despachos',
    API_GET_REPORTE_VENTAS_PLACA: SERVER_KUBBER + '/kubber/movimientos/api/v1/lista/placa',
    API_GET_REPORTE_VENTAS_HORAS: SERVER_KUBBER + '/kubber/movimientos/api/v1/reporte/ventas/horas',


    API_GET_DASHBOARD_RESUMEN_VENTA: SERVER_KUBBER + '/kubber/movimientos/api/v1/resumen',
    API_GET_DASHBOARD_RESUMEN_SEMANAL: SERVER_KUBBER + '/kubber/movimientos/api/v1/xresumen/ultima_semana',
    API_GET_DASHBOARD_REPORTE_ANUAL: SERVER_KUBBER + '/kubber/movimientos/api/v1/reporte/anual',
    API_GET_DASHBOARD_REPORTE_ANUAL_CREDITO: SERVER_KUBBER + '/kubber/movimientos/api/v1/reporte/anualcredito',

    API_GET_REPORTE_CORTE: SERVER_KUBBER + '/kubber/movimientos/api/v1/corte',
    API_GET_REPORTE_TURNOS: SERVER_KUBBER + '/kubber/movimientos/api/v1/turnos',

    API_GET_FLOTA: SERVER_KUBBER + '/kubber/clientes/api/v1/flota/lista',
    API_GET_FLOTA_CREAR: SERVER_KUBBER + '/kubber/clientes/api/v1/flota/crear',
    API_GET_FLOTA_ACTUALIZAR: SERVER_KUBBER + '/kubber/clientes/api/v1/flota/actualizar/estado',
    API_GET_FLOTA_ACTUALIZAR_FULL: SERVER_KUBBER + '/kubber/clientes/api/v1/flota/actualizar/full',

    API_POST_VEHICULO_CREAR: SERVER_KUBBER + '/kubber/clientes/api/v1/flota/vehiculos/crear',
    API_POST_VEHICULO_REMOVER: SERVER_KUBBER + '/kubber/clientes/api/v1/flota/vehiculos/remover',
    API_GET_VEHICULO_ID: SERVER_KUBBER + '/kubber/clientes/api/v1/vehiculos/id',
    API_GET_IBUTTON_ID: SERVER_KUBBER + '/kubber/clientes/api/v1/ibutton/libres',

    API_CLIENTES_FIND: SERVER_KUBBER + '/kubber/clientes/api/v1/documento',
    API_GET_REPORTE_CLIENTES: SERVER_KUBBER + '/kubber/clientes/api/v1/lista',
    API_PUT_EDITAR_CLIENTES: SERVER_KUBBER + '/kubber/clientes/api/v1/editar',
    API_POST_CREAR_FACTURA: SERVER_KUBBER + '/kubber/facturacion/api/v1/crear',
    API_POST_CREAR_CLIENTES: '/comandos/api/parametros/terceros/',
    API_GET_REPORTE_CLIENTES_RECARGA: SERVER_KUBBER + '/kubber/clientes/api/v1/recargas',
    API_GET_REPORTE_CLIENTES_SALDO: SERVER_KUBBER + '/kubber/clientes/api/v1/saldo',
    API_GET_REPORTE_CLIENTES_EXTRACTO: SERVER_KUBBER + '/kubber/clientes/api/v1/extracto',

    API_GET_LISTA_DOCUMENTOS: '/comandos/api/parametros/criterio/' + btoa('DOCUMENTO'),
    API_GET_LISTA_PAIS: '/comandos/api/parametros/paises',
    API_GET_LISTA_DEPARTAMENTOS_FULL: '/comandos/api/parametros/provincias/' + btoa('codepais'),
    API_GET_LISTA_CIUDADES_FULL: '/comandos/api/parametros/ciudades/' + btoa('codeprovinciapais'),
    API_GET_LISTA_CIUDADES: SERVER_KUBBER + "/kubber/servicios/api/v1/common/list/municipality",
    API_GET_LISTA_DEPARTAMENTOS: SERVER_KUBBER + "/kubber/servicios/api/v1/common/list/department",

    API_GET_LISTA_CATALOGO_MEXICO:  SERVER_KUBBER + "/kubber/servicios/api/v1/common/catalogos/mx",
    API_GET_LISTA_PRODUCTOS_MEXICO: SERVER_KUBBER + "/kubber/facturacion/api/v1/factura/productos",
    API_GET_LISTA_ALL_PRODUCTOS_MEXICO: SERVER_KUBBER + "/kubber/facturacion/api/v1/factura/productos-all",

    API_GET_LISTA_ATRIBUTOS_EMPRESA: SERVER_KUBBER + "/kubber/facturacion/api/v1/parametros",
    API_CREAR_VENTA_MEXICO_ELECTRONICA: SERVER_KUBBER + "/kubber/facturacion/api/v1/crear/factutar40",
    API_ENVIAR_VENTA_MEXICO_ELECTRONICA: SERVER_KUBBER + "/kubber/facturacion/api/v1/enviar/factutar40",
    API_CONSULTA_VENTA_MEXICO_ELECTRONICA: SERVER_KUBBER + "/kubber/facturacion/api/v1/consulta/factutar40",
    API_PREVIEW_FACTURA_ELECTRONICA: SERVER_KUBBER + '/kubber/facturacion/api/v1/preview/factura40',
    API_CANCELAR_FACTURA_MEXICO_ELECTRONICA: SERVER_KUBBER + '/kubber/facturacion/api/v1/cancelar/factura40',
    API_INACTIVAR_FACTURA_MEXICO_ELECTRONICA: SERVER_KUBBER + '/kubber/facturacion/api/v1/inactivar/factutar40',
    API_OPCIONES_FACTURA_MEXICO_ELECTRONICA: SERVER_KUBBER + '/kubber/facturacion/api/v1/opciones/factutar40',
    API_CREAR_VENTA_POS_MEXICO_ELECTRONICA: SERVER_KUBBER + "/kubber/facturacion/api/v1/pos/facturar",


    API_ENVIAR_NOTACREDITO_MEXICO_ELECTRONICA: SERVER_KUBBER + "/kubber/facturacion/api/v1/crear/notacredito40",
    API_CONSULTA_NOTACREDITO_MEXICO_ELECTRONICA: SERVER_KUBBER + "/kubber/facturacion/api/v1/consulta/notacredito40",

    API_CANCELAR_FACTURA_COLOMBIA_ELECTRONICA: SERVER_KUBBER + '/kubber/facturacion/api/v1/anulacion',

    API_VEHICULOS_LISTA: SERVER_KUBBER + '/kubber/vehiculos/api/v1/lista',
    API_VEHICULOS_CREAR: SERVER_KUBBER + '/kubber/vehiculos/api/v1/crear',
    API_VEHICULOS_ACTUALIZA: SERVER_KUBBER + '/kubber/vehiculos/api/v1/actualizar',
    API_VEHICULOS_FIND: SERVER_KUBBER + '/kubber/vehiculos/api/v1/placa',
    API_VEHICULOS_IDENTIFICADORES_FIND: SERVER_KUBBER + '/kubber/vehiculos/api/v1/identificadores',


    API_ACUERDOS_LISTA: SERVER_KUBBER + '/kubber/vehiculos/api/v1/acuerdos',
    API_ACUERDOS_UPDATE: SERVER_KUBBER + '/kubber/vehiculos/api/v1/acuerdos',
    API_ACUERDOS_CREATE: SERVER_KUBBER + '/kubber/vehiculos/api/v1/acuerdos',

    API_ALIANZAS_LISTA: SERVER_KUBBER + '/kubber/vehiculos/api/v1/alianzas',
    API_ALIANZAS_UPDATE: SERVER_KUBBER + '/kubber/vehiculos/api/v1/alianzas',

    API_REPORTE_RECAUDOS: SERVER_KUBBER + '/kubber/vehiculos/api/v1/recaudos',

    API_CONVERSION_CREAR: SERVER_KUBBER + '/kubber/vehiculos/api/v1/conversion/crear',

    API_GENERA_DESCUENTO_FACTURA: SERVER_KUBBER + '/kubber/movimientos/api/v1/descuentos',

    API_GET_PERSONA: SERVER_KUBBER + '/kubber/servicios/api/v1/usuarios',

    API_SEND_HTML_EXCEL: SERVER_KUBBER + '/kubber/movimientos/api/v1/lista/from-html',
    API_IMPORT_FILE_CVS: SERVER_KUBBER + '/kubber/vehiculos/api/import/archivo',



     API_PRODUCTO_PRECIO_CLIENTE_LISTA: SERVER_KUBBER + "/kubber/clientes/api/v1/precios/lista",
     API_PRODUCTO_PRECIO_CLIENTE_CREAR: SERVER_KUBBER + "/kubber/clientes/api/v1/precios/crear",
     API_PRODUCTO_PRECIO_CLIENTE_ELIMINAR: SERVER_KUBBER + "/kubber/clientes/api/v1/precios/eliminar",




    APIS_PLEMSIS: {
        IS_PRODUCCION: true,
        IS_GET_CIUDADES: true,
        API_PRUEBA: "2850c2d3270289fb90daee9e",
        API_PRODUCCION: "e24b6d452cec95a0af38af58",
        CIUDADES: "https://api.plemsi.com/api/common/list/municipality"
    },

    LOGIN: false,
    USER: null,

    TIPO_ORIGEN: {
        COMBUSTIBLE: 8,
        CANASTILLA: 6,
    },

    CREDITO_OPERACION: {
        1: "CREDITO LIBRE",
        2: "CREDITO CON CUPO CLIENTE",
        3: "CREDITO CON CUPO FLOTA"
    },

    DOCUMENTO_ID: {
        20: "FACTURA POS",
        27: "FACTURA ELECTRONICA",
        24: "DESPACHO CONTADO",
        29: "DESPACHO CREDITO",
        34: "PREFORMA"
    },

    DOCUMENTO: {
        FACTURA_POS: 20,
        FACTURA_ELECTRONICA: 27,
        DESPACHO_CONTADO: 24,
        DESPACHO_CREDITO: 29,
        PREFORMA: 34
    },

    COLOR: {
        RED: "#C91C1E",
        BLUE: "#2273A8"
    },

    PERMISOS: {
        DASHBOARD: {
            SCADARESUMEN: "cc8d2382-73c7-495b-8382-02db80acc592",
            SCADANODOS: "49a63cd0-95c1-4113-b46b-45f8ae6759e4",
            SCADAMAPA: "3f367976-9b8b-4bc1-a524-375c02597dc4",
            SCADACHART: "a7b10db1-7fda-48ae-b82a-e16ab424e8a6",
        },

        REPORTE: {
            HOROMETRO: "13f334d1-2320-4f64-8748-e37820a6ed0b"
        },

        USUARIOS: {
            LISTAR: "299f1564-8188-4dd8-b831-154c1fab8cda",
        },

        FACTURADOR: {
            CREAR: "4576346a-0a69-467c-914e-ac26853e8225",
        },
    },

    CATALOGO_MEXICO: {
        USO_CFDI: "1",
        REGIMEN_FISCAL: "2",
        METODO_PAGO: "3",
        FORMA_PAGO: "4",
        TIPO_VENTA: "5",
        TIPO_DOCUMENTO: "6",
        PERIORICIDAD: "7",
    },

    MENU_FACTURADOR: [
        {
            descripcion: 'Facturador POS',
            to: '/facturadorPOS',
            icon: 'fa-solid fa-user-tie menuitem',
            disponible: ['CO', 'MX']
        }
    ],


    MENU_TALLER: [
        {
            descripcion: 'Gestión de Clientes',
            to: '/clientes',
            icon: 'fa-solid fa-user-tie menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Gestión de Vehiculos',
            to: '/vehiculos',
            icon: 'fa-solid fa-car menuitem',
            disponible: ['MX']
        },
        {
            descripcion: 'Importar vehiculos',
            to: '/importador',
            icon: 'fa-solid fa-car menuitem',
            disponible: ['MX']
        },
        {
            descripcion: 'Conversiones',
            to: '/conversiones',
            icon: 'fa-solid fa-wrench menuitem',
            disponible: ['MX']
        },
    ],

    MENU_FINANCIERA: [
        {
            descripcion: 'Entidades/Alianzas',
            to: 'entidades-acuerdos',
            icon: 'fa-solid fa-gas-pump menuitem',
            disponible: ['MX']
        },
        {
            descripcion: 'Gestión de Recaudos',
            to: '/recaudos',
            icon: 'fa-solid fa-user-tie menuitem',
            disponible: ['MX']
        },
        {
            descripcion: 'Reporte de Recaudos',
            to: '/reporte-recaudos',
            icon: 'fa-solid fa-list-check menuitem',
            disponible: ['MX']
        }
    ],

    MENU_EDS: [
        {
            descripcion: 'Dashboard',
            to: '/home',
            icon: 'fa-solid fa-chart-line menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Corte Diario',
            to: '/reportes/corte',
            icon: 'fa-solid fa-table-list menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Turnos',
            to: '/reportes/turnos',
            icon: 'fa-regular fa-clock menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Ventas Combustible',
            to: '/reportes/ventas',
            icon: 'fa-solid fa-gas-pump menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Ventas Canastilla',
            to: '/reportes/ventas_documento',
            icon: 'fa-solid fa-bottle-water menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Ventas por Placa',
            to: '/reportes/ventas_placa',
            icon: 'fa-solid fa-car-rear menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Ventas por Horas',
            to: '/reportes/ventas_horas',
            icon: 'fa-solid fa-chart-simple menuitem',
            disponible: ['CO', 'MX'],
        },
         {
            descripcion: 'Tickets/Factura',
            to: '/reportes/conciliaciones',
            icon: 'fa-solid fa-list-check menuitem',
            disponible: ['MX']
        },
        {
            descripcion: 'Facturas Electrónicas',
            to: '/reportes/felectronica',
            icon: 'fa-solid fa-file-invoice-dollar menuitem',
            disponible: ['CO', 'MX']
        },
        {  
            descripcion: 'Facturador GNV',
            to: '/facturador/facturador',
            icon: 'fa-solid fa-cash-register menuitem',
            disponible: ['MX']
        },
        {
            descripcion: 'Facturador FILLPOS',
           to: '/facturador/facturadorPOS',
            icon: 'fa-solid fa-file-invoice menuitem',
            disponible: ['MX']
        },
         {
            descripcion: 'Precios Facturación',
            to: '/cliente-precio', 
            icon: 'fa-solid fa-hand-holding-dollar menuitem',
            disponible: ['MX'],
            nuevo: 'S',
        },
        {
            descripcion: 'Descuentos',
            to: '/descuentos',
            icon: 'fa-solid fa-ticket menuitem',
            disponible: ['MX']
        },
        
        {
            descripcion: 'Notas Créditos',
            to: '/reportes/ncelectronica',
            icon: 'fa-solid fa-file-invoice-dollar menuitem',
            disponible: ['MX']
        },
        {
            descripcion: 'Clientes',
            to: '/clientes',
            icon: 'fa-solid fa-user-tie menuitem',
            disponible: ['CO', 'MX']
        },
       
        {
            descripcion: 'Recargas Creditos',
            to: '/recargas',
            icon: 'fa-solid fa-comments-dollar menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Extracto de Clientes',
            to: '/extracto',
            icon: 'fa-solid fa-sack-dollar menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Gestión de Flotas',
            to: '/flotas',
            icon: 'fa-solid fa-car-side menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Despachos',
            to: '/clientes/despachos',
            icon: 'fa-sharp fa-solid fa-clipboard-list menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Usuarios',
            to: '/usuarios',
            icon: 'fa-solid fa-users menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Parametros',
            to: '/parametros-empresa',
            icon: 'fa-solid fa-screwdriver-wrench menuitem',
            disponible: ['MX']
        },
        {
            descripcion: 'Entidades/Alianzas',
            to: '/entidades-acuerdos',
            icon: 'fa-solid fa-gas-pump menuitem',
            disponible: ['MX']
        },
        {
            descripcion: 'Reporte de Recaudos',
            to: '/reporte-recaudos',
            icon: 'fa-solid fa-list-check menuitem',
            disponible: ['MX']
        }
    ],


    MENU_FACTURADOR_ADMIN: [
        {
            descripcion: 'Dashboard',
            to: '/home',
            icon: 'fa-solid fa-chart-line menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Corte Diario',
            to: '/reportes/corte',
            icon: 'fa-solid fa-table-list menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Turnos',
            to: '/reportes/turnos',
            icon: 'fa-regular fa-clock menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Ventas Combustible',
            to: '/reportes/ventas',
            icon: 'fa-solid fa-gas-pump menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Ventas Canastilla',
            to: '/reportes/ventas_documento',
            icon: 'fa-solid fa-bottle-water menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Tickets/Factura',
            to: '/reportes/conciliaciones',
            icon: 'fa-solid fa-list-check menuitem',
            disponible: ['MX'],
            nuevo: 'S',
        },
        {
            descripcion: 'Ventas por Placa',
            to: '/reportes/ventas_placa',
            icon: 'fa-solid fa-car-rear menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Ventas por Horas',
            to: '/reportes/ventas_horas',
            icon: 'fa-solid fa-chart-simple menuitem',
            disponible: ['CO', 'MX'],
            nuevo: 'S',
        },
        {
            descripcion: 'Facturador',
            to: '/facturador/facturador',
            icon: 'fa-solid fa-cash-register menuitem',
            disponible: ['MX']
        },
        {
            descripcion: 'Descuentos',
            to: '/descuentos',
            icon: 'fa-solid fa-ticket menuitem',
            disponible: ['MX']
        },
        {
            descripcion: 'Factura Electrónica',
            to: '/reportes/felectronica',
            icon: 'fa-solid fa-file-invoice-dollar menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Notas Créditos',
            to: '/reportes/ncelectronica',
            icon: 'fa-solid fa-file-invoice-dollar menuitem',
            disponible: ['MX']
        },
        {
            descripcion: 'Gestión de Clientes',
            to: '/clientes',
            icon: 'fa-solid fa-user-tie menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Recargas Creditos',
            to: '/recargas',
            icon: 'fa-solid fa-comments-dollar menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Extracto de Clientes',
            to: '/extracto',
            icon: 'fa-solid fa-sack-dollar menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Gestión de Flotas',
            to: '/flotas',
            icon: 'fa-solid fa-car-side menuitem',
            disponible: ['CO', 'MX']
        },
    ],

    MENU_LIMIT: [
        {
            descripcion: 'Dashboard',
            to: '/home',
            icon: 'fa-solid fa-chart-line menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Corte Diario',
            to: '/reportes/corte',
            icon: 'fa-solid fa-table-list menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Turnos',
            to: '/reportes/turnos',
            icon: 'fa-regular fa-clock menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Ventas Combustible',
            to: '/reportes/ventas',
            icon: 'fa-solid fa-gas-pump menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Ventas Canastilla',
            to: '/reportes/ventas_documento',
            icon: 'fa-solid fa-bottle-water menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Ventas por Placa',
            to: '/reportes/ventas_placa',
            icon: 'fa-solid fa-car-rear menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Descuentos',
            to: '/descuentos',
            icon: 'fa-solid fa-ticket menuitem',
            disponible: ['MX']
        },
        {
            descripcion: 'Facturador',
            to: '/facturador/facturador',
            icon: 'fa-solid fa-cash-register menuitem',
            disponible: ['MX']
        },
        {
            descripcion: 'Factura Electrónica',
            to: '/reportes/felectronica',
            icon: 'fa-solid fa-file-invoice-dollar menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Gestión de Clientes',
            to: '/clientes',
            icon: 'fa-solid fa-user-tie menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Recargas Creditos',
            to: '/recargas',
            icon: 'fa-solid fa-comments-dollar menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Extracto de Clientes',
            to: '/extracto',
            icon: 'fa-solid fa-sack-dollar menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Gestión de Flotas',
            to: '/flotas',
            icon: 'fa-solid fa-car-side menuitem',
            disponible: ['CO', 'MX']
        },
        {
            descripcion: 'Despachos',
            to: '/clientes/despachos',
            icon: 'fa-sharp fa-solid fa-clipboard-list menuitem',
            disponible: ['CO', 'MX']
        },
    ],

    FORMATO_MILISEGUNDOS_HORAS(duration) {
        var minutes = Math.floor((duration / (1000 * 60)) % 60),
            hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

        hours = (hours < 10) ? "0" + hours : hours;
        minutes = (minutes < 10) ? "0" + minutes : minutes;

        return (hours) + ":" + (minutes);
    },

    FORMATO_MONEY(number) {
        if (isNaN(number)) {
            number = 0;
        }
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 }).format(number);
    },

    FORMATO_MONEY_BASIC(number) {
        if (isNaN(number)) {
            number = 0;
        }
        if (this.COUNTRY == "CO") {
            return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(number);
        } else {
            return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(number);
        }
    },

    FORMATO_NUMBER(number) {
        if (isNaN(number)) {
            number = 0;
        }
        return new Intl.NumberFormat('en-US', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(number);
    },

    FORMATO_NUMBER_BASIC(number) {
        return new Intl.NumberFormat('en-US', {
            style: 'decimal',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(number);
    },

    FORMATO_CORREO_VALIDO(valor) {
        if (/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(valor)) {
            return true;
        } else {
            return false;
        }
    },

    FORMATO_FECHA(date) {
        let ano = date.getFullYear();
        let mes = ((date.getMonth() + 1) <= 9 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1))
        let dia = date.getDate() <= 9 ? "0" + date.getDate() : date.getDate();
        return ano + "-" + mes + "-" + dia;
    },

    FORMATO_TEXTO_FULL_FECHA(date) {
        const meses = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC']

        var fecha = date.split("T")[0]
        var tiempo = date.split("T")[1].split(".")[0]
        var mes = (parseInt(fecha.split("-")[1])) - 1
        return "(" + meses[mes] + "/" + fecha.split("-")[2] + ") " + tiempo;
    },

    SELECCION_MES(valor) {
        const meses = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC']
        return meses[valor];
    },

    SOLO_ALFANUMERICOS(event) {
        var regex = new RegExp("^[a-zA-Z0-9]+$");
        var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        if (!regex.test(key)) {
            event.preventDefault();
            return false;
        }
    },

    SOLO_NUMEROS(event) {
        var regex = new RegExp("^[0-9]+$");
        var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        if (!regex.test(key)) {
            event.preventDefault();
            return false;
        }
    },

    SOLO_DECIMALES(event) {
        var input = event.target.value + String.fromCharCode(event.charCode);
        var regex = /^\d*\.?\d*$/;
        if (!regex.test(input)) {
            event.preventDefault();
            return false;
        }
    },

    NOW() {
        var currentDate = new Date();
        var timezoneOffset = currentDate.getTimezoneOffset();
        currentDate.setMinutes(currentDate.getMinutes() - timezoneOffset);
        var formattedDate = currentDate.toISOString().slice(0, 19).replace('T', ' ');
        return formattedDate;
    },

    NOW_ISO() {
        var currentDate = new Date();
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        var timezoneOffset = currentDate.getTimezoneOffset();
        currentDate.setMinutes(currentDate.getMinutes() - timezoneOffset);

        var formattedDate = currentDate.toISOString().slice(0, 19) + "Z";
        return formattedDate;
    },

    NOW_WITH_TZ(uso_horario) {
        var fecha = new Date();
        var offsetHorario = uso_horario * 60;
        var offsetActual = fecha.getTimezoneOffset();
        var offsetTotal = (offsetHorario + offsetActual) * 60 * 1000;
        var horaExacta = new Date(fecha.getTime() + offsetTotal);

        // Obtener los componentes de la fecha y hora
        var year = horaExacta.getFullYear();
        var month = ("0" + (horaExacta.getMonth() + 1)).slice(-2);
        var day = ("0" + horaExacta.getDate()).slice(-2);
        var hours = ("0" + horaExacta.getHours()).slice(-2);
        var minutes = ("0" + horaExacta.getMinutes()).slice(-2);
        var seconds = ("0" + horaExacta.getSeconds()).slice(-2);

        // Formatear la hora exacta en el formato deseado
        var formattedDate = year + "-" + month + "-" + day + "T" + hours + ":" + minutes + ":" + seconds + "Z";

        return formattedDate;
    },

    CALCULAR_IVA(importeTotal, porcentajeIVA) {
        const importeSinIVA = importeTotal / (1 + porcentajeIVA / 100);
        return importeTotal - importeSinIVA;
    },

    ES_UUID(valor) {
        // Expresión regular para verificar UUID v4
        const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        return uuidRegex.test(valor);
    },


    TABLE_OPTIONS: {
        dom: "<'btt row'<'col-sm-2'l><'col-sm-4'B><'col-sm-6'f>>" +
            "<'row'<'col-sm-12'tr>>" +
            "<'btt row'<'col-sm-5'i><'col-sm-7'p>>",
        buttons: [
            {
                extend: 'copyHtml5',
                text: '<i class="fa-regular fa-clipboard"></i>'
            },
            {
                extend: 'excelHtml5',
                text: '<i class="fa-regular fa-file-excel"></i>'
            },
            {
                extend: 'csvHtml5',
                text: '<i class="fa-solid fa-file-csv"></i>'
            },
            {
                extend: 'pdfHtml5',
                text: '<i class="fa-regular fa-file-pdf"></i>'
            }
        ],
        responsive: false,
        lengthMenu: [[10, 20, 50, -1], [10, 20, 50, "Todos"]],
        language: {
            "url": "plugins/Spanish.json",
        },
        scrollX: true,
        autoWidth: false,  // Desactiva el auto ajuste para que respete los anchos personalizados
        columnDefs: [
            {
                targets: 1,  // El índice de la columna 'Flota', empieza en 0
                width: "300px"  // Establecer un ancho fijo solo para esta columna
            }
        ],
    },

}



// Encode the String
//var encodedString = Base64.encode(string);
//console.log(encodedString); // Outputs: "SGVsbG8gV29ybGQh"

// Decode the String
//var decodedString = Base64.decode(encodedString);
//console.log(decodedString); // Outputs: "Hello World!"